import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'goods', // 资源路径
    defaultRels: ['comments'], // 默认需要的关联数据
    defaultQuery: { 'type': 'normal' } // 默认的通用查询

  }

})
